import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import { withRouter } from './withRouter';
import WheelComponent from './Wheel';
//import 'react-wheel-of-prizes/dist/index.css';
import Game from "../components/Games/Game";
import GameAddon from "../components/Games/GameAddon";
import GameList from "constants/GameList";
import GamePackList from "constants/GamePackList";
import GameAddonList from "constants/GameAddonList";
import styles from './HomeStyles.module.scss';
import "./HomeStyles.module.scss";

import Reviews from "constants/reviews";
import SummerSaleHero from 'components/Heros/SummerSale/SummerSaleHero'

// Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carouselStyles.css";
import Slider from "react-slick";
import StarFull from "images/template/full-star.png";
import StarEmpty from "images/template/empty-star.png";
import promotionService from '../services/promotion.service';
import GamePack from './Games/GamePack';
import ReactPlayer from 'react-player';

import BlackFridayBanner from "images/heros/black-friday.png";
import BlackFridayBannerMob from "images/heros/black-friday-mob.png";
import YCSUBanner from "images/heros/ycsu.png";
import YCSUBannerMini from "images/heros/ycsu-mini.png";
import bestSellersTitle from "images/heros/BestsellersTitle.png";
import AmazingGames from "images/heros/11 Amazing Games.png";
import FunForAll from "images/heros/Fun for All Ages.png";
import InstantDelivery from "images/heros/Instant Delivery.png";
import kickstarterLogo from 'images/kickstarter-logo.png';
import cityScape from "images/heros/Autumn Sale/CityScape.png"

import LifeStyle1 from "images/lifestyles/lifestyle-1.png";
import LifeStyle2 from "images/lifestyles/lifestyle-2.png";
import LifeStyle3 from "images/lifestyles/lifestyle-3.png";

import DONDStudio from "images/Promotions/dond-banner-v2.png";
import DONDLogo from "images/Promotions/dond-logo.png";
import GameCityRewardsBanner from './Heros/GameCityRewardsBanner/GameCityRewardsBanner';
import AutumnSaleHero from './Heros/AutumnSale/AutumnSaleHero';
import DefaultHero from './Heros/DefaultHero/DefaultHero';
import BestSellers from './Heros/BestSellers/BestSellers';

const infoBoxes = [
    {
        title: "PARTY GAMES ON YOUR TV",
        description: "Play on any screen with a web browser. Around the TV or even remotely.",
        image: LifeStyle1,
    },
    {
        title: "BUY ONCE, PLAY FOREVER",
        description: "Just one person needs to buy and host the game. Setup a game in seconds.",
        image: LifeStyle2
    },
    {
        title: `UP TO 8 PLAYERS`,
        description: "No dice, no cards...no boring waiting for your turn. Use your phone as a controller.",
        image: LifeStyle3
    }
];

class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);

        this.state = {
            isOpenPromotion: false,
            currentPromotion: null,
            segColors: [],
            segments: [],
            winningSegment: "",
            isEmailStep: false,
            promotionEmail: "",
            promotionSubmitting: false,
            promotionError: null,
            promotionSuccess: false,
            awardedPromotionCode: null,
            awardedVouchercode: null,
        };
        this.wheelRef = React.createRef(null);
    }

    carouselSettings = {
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        customPaging: function (i) {
            return (
                <div className="carousel-dot">

                </div>
            );
        },
    };


    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search);
        console.log(queryParams);
        if (queryParams.has("token")) {
            console.log("has params");
            setTimeout(() => this.props.navigate(`/join?token=${queryParams.get("token")}`));
        } else {
            this.checkForPromotion();
        }
    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }


    async checkForPromotion() {
        const promotionresult = await promotionService.getActivePromotion();
        if (promotionresult.data.status === "Success") {
            var date = new Date();
            var day, month, year;
            day = date.getDate();
            month = date.getMonth();
            year = date.getFullYear();
            if ((localStorage.getItem(`seen_promotion_${promotionresult.data.activePromotion.id}_${day}-${month}-${year}`) == null && localStorage.getItem(`won_promotion_${promotionresult.data.activePromotion.id}`) == null)) {
                let segments = [...this.state.segments];
                let segColors = [...this.state.segColors];
                if (promotionresult.data.activePromotion.promotionType === 0) {
                    promotionresult.data.activePromotion.promotionCodes?.forEach((x, i, arr) => {
                        segments.push(x.description);
                        segColors.push("#FF5F6B");
                        if ((arr.length > 3 && i % 2 === 0) || arr.length <= 3) {
                            segments.push(" ");
                            segColors.push("#65BECD");
                        }
                    });
                } else {
                    promotionresult.data.activePromotion.promotionGames?.forEach((x, i, arr) => {
                        segments.push(x.description);
                        segColors.push("#FF5F6B");
                        if ((arr.length > 3 && i % 2 === 0) || arr.length <= 3) {
                            segments.push(" ");
                            segColors.push("#65BECD");
                        }
                    });
                }

                this.setState({
                    //isOpenPromotion: true,
                    currentPromotion: promotionresult.data.activePromotion,
                    segments,
                    segColors,
                });
                //segments = this.shuffleArray(segments);
            }
        }
    }

    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    submitPromotionForm = (event) => {
        event.preventDefault();
        console.log("Email : ", this.state.promotionEmail);
        console.log("promotionSubmitting : ", this.state.promotionSubmitting);

        if (this.state.promotionEmail.length > 0 && !this.state.promotionSubmitting) {
            console.log("Submitting...");
            this.setState({ promotionSubmitting: true, promotionError: null, });
            promotionService.submitPromotionEntry(this.state.currentPromotion.id, this.state.promotionEmail, this.props.pricing.countryCode)
                .then((res) => {
                    console.log(`Promotion Submit Result : `, res);
                    if (res.data.status === "Success") {
                        if (!res.data.promotionCode && !res.data.promotionGame) {
                            this.setState({ winningSegment: " " });
                        } else {
                            if (this.state.currentPromotion.promotionType === 0) {
                                this.setState({ awardedPromotionCode: res.data.promotionCode, winningSegment: res.data.promotionCode.description });
                            } else {
                                this.setState({ awardedVouchercode: res.data.promotionGame.description, winningSegment: res.data.promotionGame.description });
                            }
                            localStorage.setItem(`won_promotion_${this.state.currentPromotion.id}`, "true");
                        }

                        var date = new Date();
                        var day, month, year;
                        day = date.getDate();
                        month = date.getMonth();
                        year = date.getFullYear();
                        localStorage.setItem(`seen_promotion_${this.state.currentPromotion.id}_${day}-${month}-${year}`, "true");
                        setTimeout(() => {
                            this.wheelRef.current.spin();
                        }, 1000);

                    } else {
                        this.setState({ promotionSubmitting: false, promotionError: res.data.reason, });
                    }
                }).catch((err) => {
                    console.log(`Promotion Submit Error : `, err);
                    this.setState({ promotionSubmitting: false, promotionError: err, });
                });
        }
    }

    updatePromotionEmail = (event) => {
        const value = event.target.value;
        console.log("Updating Email");
        this.setState({ promotionEmail: value });
    }

    onFinished = (winner) => {
        console.log(winner)
        setTimeout(() => {
            this.setState({ promotionSuccess: true, });
        }, 2000);
    }

    closePromotionModal = (clearPromotion = true) => {
        if (clearPromotion) this.setState({ currentPromotion: null });
        this.setState({ isOpenPromotion: false, });
    }

    isDev() { return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development' }

  

    isBlackFriday() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startDate = new Date('2024-11-21T00:00:00');
        const endDate = new Date('2024-12-03T23:59:59');

        if (today >= startDate && today <= endDate) {
            return true;
        } else {
            return false;
        }
    }

    isMobileWidth() {
        console.log("inner width : ", window.innerWidth);
        return window.innerWidth < 600;
    }


    render() {
        return (
            <React.Fragment>
                <div className={styles.pageHome}>
                    <div className={styles.cloudBG } />
                    <div className={styles.blueBg} />
                    <DefaultHero />
                    {/*<AutumnSaleHero />*/}
                    {/*<div className={styles.actionButtons}>*/}
                    {/*    <button onClick={() => this.props.navigate("/join")} className={`${styles.button} ${styles.medium} ${styles.wide}`}>JOIN GAME</button>*/}
                    {/*    <button onClick={() => this.props.navigate("/lobby")} className={`${styles.button} ${styles.medium} ${styles.wide}`}>HOST GAME</button>*/}

                    {/*    */}{/*<button onClick={() => this.props.navigate("/lobby")} className={`${styles.button} ${styles.medium} ${styles.wide} ${styles.host}`}>HOST GAME</button>*/}
                    {/*</div>*/}
                    <GameCityRewardsBanner color={null} />

                    {/*<section className={styles.kickstarterSection}>*/}
                    {/*    <Container className={`p-1 p-md-5 ${styles.kickstarterHero}`}>*/}
                    {/*        <img src={DONDStudio} className={styles.hero} />*/}
                    {/*        <Row className="h-100 w-100" style={{minHeight: "fit-content"}}>*/}
                    {/*            <Col xs={12} lg={4} className={`${styles.kickCol} ${styles.fadingBg}`}>*/}
                    {/*                <div className={`${styles.item} ${styles.comingSoon}`}>COMING SOON</div>*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={12} lg={4} className={`${styles.kickCol}`}>*/}
                    {/*                <img src={DONDLogo} className={styles.logo} onClick={ () => this.props.navigate("/shop/deal-or-no-deal")} />*/}
                    {/*            </Col>*/}
                    {/*            <Col xs={12} lg={4} className={`${styles.kickCol} ${styles.fadingBgFlip}`}>*/}
                    {/*                <button className={`${styles.item} ${styles.button} ${styles.kickstarter}`} onClick={() => this.openInNewTab("https://www.kickstarter.com/projects/1169339123/1485717407?ref=5by6bq") }>*/}
                    {/*                    FIND OUT MORE ON*/}
                    {/*                    <br />*/}
                    {/*                    <img src={kickstarterLogo} className={styles.kickstarterLogo}></img>*/}
                    {/*                </button>*/}
                    {/*            </Col>*/}
                    {/*        </Row>*/}
                    {/*    </Container>*/}
                    {/*    <header className={styles.kickstarterBanner}>SUPPORT THE NEW PARTY GAME OF DEAL OR NO DEAL - NOW LIVE ON KICKSTARTER!</header>*/}
                    {/*</section>*/}
                    {/*<SummerSaleHero/>*/}
                    {/*<header className={styles.buttonBanner}>*/}
                    {/*    <button onClick={() => this.props.navigate("/join")} className={`${styles.button} ${styles.large}`} style={{ paddingLeft: "35px", paddingRight: "35px" }}>JOIN GAME</button>*/}
                    {/*    <button onClick={() => this.props.navigate("/lobby")} className={`${styles.button} ${styles.large} ${styles.alternate}`} style={{paddingLeft: "35px", paddingRight: "35px"} }>HOST GAME</button>*/}
                    {/*</header>*/}

                    <section className={`${styles.mainContent}`}>
                        <div className={styles.calloutSection}>
                            <BestSellers />


                            <div>
                                <Row className={`row ${styles.infoBoxes}`}>
                                    {
                                        infoBoxes.map((box, i) => {
                                            return <Col xs={12} md={4} key={`info-box-${i}`} className={`text-center my-2`}>
                                                <div className={`${styles.infoBox}`}>
                                                    <h2 className={styles.title}>{box.title}</h2>
                                                    <p className={styles.description}>{box.description}</p>
                                                    <div style={{ backgroundImage: `url(${box.image})` }} className={styles.img}>
                                                        <img src={box.image} alt={`${box.title}-lifestyleshot`} />
                                                    </div>
                                                </div>
                                            </Col>
                                        })
                                    }
                                </Row>
                            </div>
                            {/*<Container className="text-center pb-5 position-relative">*/}
                            {/*    <button onClick={() => this.props.navigate("/shop")} className={`${styles.button} ${styles.alternate}`}>SHOP NOW</button>*/}
                            {/*</Container>*/}
                            <Container className={styles.video}>
                                <ReactPlayer url="https://youtu.be/Ea3FLBQkZxU" controls id='game-city-video' className={styles.reactPlayer} width='100%' height='100%'/>
                            </Container>
                            <Container className="text-center pt-5 position-relative">
                                <button onClick={() => this.props.navigate("/shop")} className={`${styles.button} ${styles.alternate}`}>SHOP NOW</button>
                            </Container>
                            <div className={styles.cityScape}  />
                        </div>
              
                    </section>
                    <section className={`${styles.reviewsSection} ${styles.band} ${styles.large}`}>
                        <Slider className={styles.carousel} {...this.carouselSettings}>
                            {
                                Reviews.map((review, i) => {
                                    return <div key={`review-${i}`} className={`${styles.reviewWidth} container p-0`}>
                                        <div className={`${styles.reviewCard} card text-center mx-3 border-0 p-3`}>
                                            <h5 className={`${styles.reviewTitle} card-title`}>{review.name}</h5>
                                            <div className="row d-flex w-50 m-auto">
                                                {Array.from(Array(5), (e, i) => {
                                                    return <div key={`star-${i}`} className="col p-1">
                                                        <img className="img-fluid m-auto" style={{}} src={i <= review.stars - 1 ? StarFull : StarEmpty} alt="review"/>
                                                    </div>
                                                })}
                                            </div>
                                            <div className={`${styles.reviewBody} card-body`}>
                                                <p className={`${styles.reviewText} card-text`}>{review.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </Slider>
                    </section>
                </div>
                {/*{*/}
                {/*    this.state.currentPromotion != null && this.state.isOpenPromotion == false &&*/}
                {/*    <div className={styles.promotionPopout} onClick={() => this.setState({ isOpenPromotion: true })}>*/}
                {/*        <img src={PopoutTato} className={styles.popoutTato} />*/}
                {/*    </div>*/}
                {/*}*/}
                {/*<Offcanvas id="ModalPromotion" backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered className={styles.modalPromotion} show={this.state.isOpenPromotion} onHide={() => this.setState({ isOpenPromotion: false })}>*/}
                {/*    <Offcanvas.Body className={`${styles.modalPromotionBody} text-center`} >*/}
                {/*        <CloseButton variant="white" style={{ display: "block", marginLeft: "auto", }} onClick={() => this.closePromotionModal(this.state.promotionSuccess)} />*/}
                {/*        {*/}
                {/*            this.state.promotionSuccess ?*/}
                {/*                <React.Fragment>*/}
                {/*                    {*/}
                {/*                        (this.state.awardedPromotionCode == null && this.state.awardedVouchercode == null) ?*/}
                {/*                            <React.Fragment>*/}
                {/*                                <div className="row py-1">*/}
                {/*                                    <p className={`${styles.promotionTitle}`}>Unlucky</p>*/}
                {/*                                </div>*/}
                {/*                                <div className="row py-1">*/}
                {/*                                    <p className={`${styles.promotionText}`}>You didn't win this time! Come back again tomorrow to try win again!</p>*/}
                {/*                                </div>*/}
                {/*                                <div className={`form-row py-1`}>*/}
                {/*                                    <button type="button" onClick={() => this.closePromotionModal(true)} className={`${styles.promotionButton} btn btn-primary w-100`} >*/}
                {/*                                        Got it!*/}
                {/*                                    </button>*/}
                {/*                                </div>*/}
                {/*                            </React.Fragment>*/}
                {/*                            :*/}
                {/*                            <React.Fragment>*/}
                {/*                                <div className="row py-1">*/}
                {/*                                    <p className={`${styles.promotionTitle}`}>Congratulations!</p>*/}
                {/*                                </div>*/}
                {/*                                <div className="row">*/}
                {/*                                    <p className={`${styles.promotionText}`}>{this.state.currentPromotion?.promotionType === 0 ? "You've won a discount:" : "You've won a free copy of:"}</p>*/}
                {/*                                </div>*/}
                {/*                                <div className="row py-1">*/}
                {/*                                    <p className={`${styles.promotionDescription}`}>{this.state.currentPromotion?.promotionType === 0 ? this.state.awardedPromotionCode.description : this.state.awardedVouchercode}</p>*/}
                {/*                                </div>*/}
                {/*                                <div className="row">*/}
                {/*                                    <p className={`${styles.promotionText}`}>Check your email for your code and instructions on how to redeem it! Please contact support if you have any issues.</p>*/}
                {/*                                </div>*/}
                {/*                                <div className={`form-row py-1`}>*/}
                {/*                                    <button type="button" onClick={this.closePromotionModal} className={`${styles.promotionButton} btn btn-primary w-100`} >*/}
                {/*                                        Awesome!*/}
                {/*                                    </button>*/}
                {/*                                </div>*/}
                {/*                            </React.Fragment>*/}
                {/*                    }*/}

                {/*                </React.Fragment>*/}
                {/*                :*/}
                {/*                <form onSubmit={this.submitPromotionForm}>*/}
                {/*                    <div className={`form-row`}>*/}
                {/*                        <h2 className={`${styles.promotionTitle}`}>{this.state.currentPromotion ? this.state.currentPromotion.promotionType === 0 ? "Want to win a discount?" : "Want to win a free game?" : ""}</h2>*/}
                {/*                    </div>*/}
                {/*                    <div className="form-row p-1">*/}
                {/*                        <p className={`${styles.promotionText}`}>Enter your email below and spin the wheel below for a chance to win!</p>*/}
                {/*                    </div>*/}
                {/*                    <div className={`form-row p-1`}>*/}
                {/*                        <input type="email" onChange={this.updatePromotionEmail} required className={`${styles.promotionInput} form-control`} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your email address" />*/}
                {/*                    </div>*/}
                {/*                    <div className={`form-row`}>*/}
                {/*                        <div className={styles.wheel}>*/}
                {/*                            <WheelComponent*/}
                {/*                                ref={this.wheelRef}*/}
                {/*                                segments={this.state.segments}*/}
                {/*                                winningSegment={this.state.winningSegment}*/}
                {/*                                segColors={this.state.segColors}*/}
                {/*                                onFinished={(winner) => this.onFinished(winner)}*/}
                {/*                                primaryColor='black'*/}
                {/*                                contrastColor='white'*/}
                {/*                                isOnlyOnce={true}*/}
                {/*                                size={145}*/}
                {/*                                upDuration={100}*/}
                {/*                                downDuration={1000}*/}
                {/*                                fontFamily='BarlowSemi'*/}
                {/*                            />*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    <div className={`form-row`}>*/}
                {/*                        <button type="submit" className={`${styles.promotionButton} btn btn-primary w-100`} >*/}
                {/*                            {*/}
                {/*                                this.state.promotionSubmitting ?*/}
                {/*                                    <div className={styles.loading}></div>*/}
                {/*                                    :*/}
                {/*                                    "SPIN SPIN SPIN!"*/}
                {/*                            }*/}
                {/*                        </button>*/}
                {/*                        {*/}
                {/*                            this.state.promotionError != null &&*/}
                {/*                            <div className="alert alert-danger mt-1" role="alert">*/}
                {/*                                {this.state.promotionError}*/}
                {/*                            </div>*/}
                {/*                        }*/}
                {/*                    </div>*/}
                {/*                    <div className={`form-row text-start p-1`}>*/}
                {/*                        <div className={`${styles.promotionFooterText}`}>*By submitting your email, you agree to receive marketing emails from The Games Collective. You can unsubscribe at any time. View our <a href={`${window.location.origin}/privacy-policy`} style={{ color: "white", }} target="_blank">privacy policy</a> for more. </div>*/}
                {/*                    </div>*/}
                {/*                    <div className={`form-row`}>*/}
                {/*                        <button type="button" disabled={this.state.promotionSubmitting} className={`${styles.promotionCancel}`} onClick={() => this.closePromotionModal(false)}>No Thanks</button>*/}
                {/*                    </div>*/}
                {/*                </form>*/}
                {/*        }*/}

                {/*    </Offcanvas.Body>*/}
                {/*</Offcanvas>*/}
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
    };
}

export default connect(mapStateToProps, null)(withRouter(Home));
